import Types from "./types";

const setVideoGalleryModalOpen = (isOpen) => ({
    type: Types.SET_VIDEO_GALLERY_MODAL_OPEN,
    isOpen
});

export {
    setVideoGalleryModalOpen
};
